export class ObjectTransformation {

  protected readonly position;
  protected readonly rotation;
  protected readonly object;

  constructor(object) {
    this.object = object;
    this.position = object.position.clone();
    this.rotation = object.rotation.clone();
  }

  restoreTransformation() {
    this.object.position.copy(this.position);
    this.object.rotation.copy(this.rotation);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/common/ObjectTransformation/ObjectTransformation.ts